import React from 'react';
import { Platform, View } from 'react-native';
import ChatInputSendButton from '@/components/ChatInput/ChatInputSendButton';
import DictateModeButton from '@/components/ChatInput/DictateModeButton';
import VoiceModeButton from '@/components/ChatInput/VoiceModeButton';
import { getComposerActionControls } from '@/components/ChatInput/composerActionSlot';

function ComposerActionButtons({
  isInferencing = false,
  isLoading = false,
  isDisabled = false,
  isCancelable = false,
  hideTextInput = false,
  hideVoiceMode = false,
  hasAllRequiredFiles = true,
  value = '',
  hasInlineParamValue = false,
  files,
  onSend,
  onTranscript,
  onDictateStateChange,
  conversationId,
  dictateAnchorRef,
  voiceButtonAnchorRef,
}) {
  const { showDictate, showVoice, showSend } = getComposerActionControls({
    isInferencing,
    hideTextInput,
    hasAllRequiredFiles,
    value,
    hasInlineParamValue,
    filesLength: files?.length || 0,
  });

  return (
    <>
      {showDictate && Platform.OS !== 'macos' && (
        <View ref={(node) => { if (dictateAnchorRef) dictateAnchorRef.current = node; }}>
          <DictateModeButton
            isDisabled={isInferencing}
            onTranscript={onTranscript}
            onDictateStateChange={onDictateStateChange}
          />
        </View>
      )}
      {showVoice && Platform.OS !== 'macos' && !hideVoiceMode && (
        <View ref={(node) => { if (voiceButtonAnchorRef) voiceButtonAnchorRef.current = node; }}>
          <VoiceModeButton
            isDisabled={isInferencing}
            conversationId={conversationId}
          />
        </View>
      )}
      {showSend && (
        <ChatInputSendButton
          onPress={onSend}
          isDisabled={isDisabled}
          isLoading={isLoading}
          isInferencing={isInferencing}
          isCancelable={isCancelable}
        />
      )}
    </>
  );
}

export default React.memo(ComposerActionButtons);
